<template>
  <div>
    <el-upload
      ref="love-upload"
      action="fakeaction"
      :on-change="onChange"
      :on-preview="onPreview"
      :on-remove="onRemove"
      :on-exceed="onExceed"
      :on-progress="onProgress"
      :on-success="onSuccess"
      :before-upload="beforeUpload"
      :before-remove="beforeRemove"
      :auto-upload="autoUpload"
      :show-file-list="showFileList"
      :multiple="multiple"
      :limit="limit"
      :accept="accept"
      :disabled="disabled"
      :drag="drag"
      :file-list="fileList"
      :list-type="listType"
      :http-request="httpRequest"
      :class="{hide:hideUpload}">
      <template v-if="(listType==='text' || listType==='picture') && !drag">
        <el-button size="mini" plain type="primary" :disabled="disabled">{{bottomText}}</el-button>
        <div slot="tip" class="el-upload__tip" v-if="showTips&&tips==''">
          <d2-icon name="exclamation-circle" style="color: red;" /> 只能上传 <span v-for="item in allowType" :key="item">{{item}} </span> 文件，且不超过 {{allowSize}} M，最多上传 {{limit}} 个文件。
        </div>
        <div slot="tip" class="el-upload__tip" v-if="showTips&&tips!=''">
          <d2-icon name="exclamation-circle" style="color: red;" /> {{tips}}
        </div>
      </template>
      <template v-if="listType==='picture-card' && !drag">
        <i class="el-icon-plus"></i>
        <div class="el-upload__tip" slot="tip" v-if="showTips&&tips==''">
          <d2-icon name="exclamation-circle" style="color: red;" /> 只能上传 <span v-for="item in allowType" :key="item">{{item}} </span> 文件，且不超过 {{allowSize}} M，最多上传 {{limit}} 个文件。
        </div>
<!--        只能上传 image/jpg image/jpeg image/png 文件，且不超过 2 M，最多上传 9 个文件。-->
        <div slot="tip" class="el-upload__tip" v-if="showTips&&tips!=''">
          <d2-icon name="exclamation-circle" style="color: red;" /> {{tips}}
        </div>
      </template>
      <template v-if="drag===true">
        <template v-if="percent==0">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip" v-if="tips==''">
            <d2-icon name="exclamation-circle" style="color: red;" /> 只能上传 <span v-for="item in allowType" :key="item">{{item}} </span> 文件，且不超过 {{allowSize}} M，最多上传 {{limit}} 个文件。
          </div>
          <div slot="tip" class="el-upload__tip" v-else>
            <d2-icon name="exclamation-circle" style="color: red;" /> {{tips}}
          </div>
        </template>
        <template v-else>
          <el-progress :percentage="percent" :color="customColorMethod" style="margin-top: 30px;" type="circle" />
        </template>
      </template>
    </el-upload>
  </div>
</template>
<script>
import { mapState } from 'vuex'

import commonModels from '@/common/models/common-models'
import md5 from 'js-md5'
export default {
  name: 'LoveElementUpload',
  props: {
    accept: {
      type: String,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fileList: {
      type: Array,
      default: () => []
    },
    listType: {
      type: String,
      default: "text"
    },
    // 开启拖拽上传
    drag: {
      type: Boolean,
      default: false
    },
    // 自动上传
    autoUpload: {
      type: Boolean,
      default: true
    },
    // 显示上传文件列表
    showFileList: {
      type: Boolean,
      default: true
    },
    // 所有允许的文件类型
    allowType: {
      type: Array,
      default: () => (["image/jpg", "image/jpeg", "image/png"])
    },
    // max file size
    allowSize: {
      type: Number,
      default: 2
    },
    // 返回视频时长
    videoDuration: {
      type: Boolean,
      default: false
    },
    // 上传文件路径参数，各模块应当不同
    lovePath: {
      type: Object,
      default: () => ({})
    },
    tips: {
      type: String,
      default: ''
    },
    // 按钮文字
    bottomText: {
      type: String,
      default: "点击上传"
    },
    showTips:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      percent: 0,
      // hack 方法 https://github.com/ElemeFE/element/issues/3367 {超过限制文件数后不显示 + 号}
      hideUpload: false,
    }
  },
  methods: {
    onChange(file, fileList) {
      console.log("change", file, fileList)
      // hack 方法
      this.hideUpload = fileList.length >= this.limit
      this.$emit('change', file, fileList)
    },
    onPreview(file) {
      console.log("preview", file)
      this.$emit('preview', file)
    },
    onRemove(file, fileList) {
      console.log("remove", file, fileList)
      // hack 方法
      this.hideUpload = fileList.length >= this.limit
      this.$emit('remove', file, fileList)
    },
    onSuccess(obj){
      console.log("success", obj)
      // 上传成功后进度条就关掉
      this.percent = 0
      console.log(obj)
      this.$emit('success', obj)
    },
    onExceed(files, fileList) {
      console.log("Exceed", files, fileList)
      this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    onProgress(progress) {
      console.log(progress)
      this.percent = progress
    },
    // 手动上传
    submit() {
      this.$refs['love-upload'].submit();
    },
    /* 自定义element文件上传
     * 根据自己项目需求改写该方法
     * httpRequest 在本地根据“要求”生成文件路径，使用 ali-oss 直传到oss存储桶
     */
    httpRequest(params) {
      console.log(this.info)
      console.log(this.bucketParameter)
      console.log(this.resourcePrefix)
      console.log(params.file)
      // 记录file以及fileType
      const file = params.file,
            fileType = params.file.type;
      // 获取文件后缀
      const file_extension = file.name.substr(file.name.lastIndexOf('.')+1, file.name.length)
      // 记录当前时间戳（精确到秒的）
      const timestamp = Date.parse(new Date()) / 1000
      // 生成文件名(当前用户的uuid + username + 时间戳 + md5(file.uid) 确保文件名在存储桶中不重复)
      const fileName = this.$store.getters.getUser.uid + "_" + this.$store.getters.getUser.uname + "_" + timestamp + "_" + md5(file.uid + '') + file.name.substr(file.name.lastIndexOf('.'), file.name.length)
      // 拼接文件路径
      let path = ""
      path += this.lovePath.module?this.lovePath.module + "/":"unknow_module" + "/"
      path += this.lovePath.source_directory?this.lovePath.source_directory + "/":"unknow_source_directory" + "/"
      path += fileName

      // 假的连接0v0，实际上只是返回一个 connect 对象
      var client = commonModels.ossConnect(this.$store.getters.getBucketParameter)
      // 若是上传的文件为视频
      if(fileType === "video/mp4" ){
        // 是否需要获取视频时长
        if (this.videoDuration) {
          let url = URL.createObjectURL(file)
          let audioElement = new Audio(url)
          var duration
          let ele = this.$refs.dur
          audioElement.addEventListener("loadedmetadata", function(_event) {
            duration = audioElement.duration
          })
        }
      }

      // 大于 2M 的使用分片上传
      if( file.size/1024/1024 >= 2 ){
        console.log("分片上传")
        // 分片上传(ps:大文件适用)
        client.multipartUpload(path, file, {
          // 进度条
          progress: function(p) {
            let percent = Math.ceil(p * 100)
            if (percent > 100) {
              percent = 100;
            }
            // element upload onProgress 上传进度钩子，以便获取实时进度
            params.onProgress(percent)
          }
        })
        .then(response => {
          // response 中有 res 参数
          const { res } = response
          if (res.status === 200) {
            // 自定义返回参数
            let data = {
              uid: file.uid, // 文件的 uid
              name: fileName, // 通过规则生成的文件名
              old_name: file.name, // 上传时的文件名
              type: fileType, // 文件上传组件判断的文件类型
              file_extension: file_extension, // 数据库目前使用的 type 是以文件后缀决定 ( 2020-04-09 APP端给的需求 )
              size: file.size, // 文件大小
              url: this.resourcePrefix.url + '/' + response.name, // url
              duration: this.videoDuration ? Math.round(duration) : "videoDuration is false.", // 视频时长
              code: 200 // 状态码
            }
            // element upload onSuccess 上传成功钩子
            params.onSuccess(data)
          }
        })
        .catch(error => {
          // element upload onError 上传失败钩子
          params.onError(error)
        })
      } else {
        console.log("文件流上传")
        client.put(path, file)
        .then(response => {
          // response 中有 res 参数
          const { res } = response
          if (res.status === 200) {
            // 自定义返回参数
            let data = {
              uid: file.uid, // 文件的 uid
              name: fileName, // 通过规则生成的文件名
              old_name: file.name, // 上传时的文件名
              type: fileType, // 文件上传组件判断的文件类型
              file_extension: file_extension, // 数据库目前使用的 type 是以文件后缀决定 ( 2020-04-09 APP端给的统以要求 )
              size: file.size, // 文件大小
              url: this.$store.getters.getResourcePrefix.url + '/' + response.name, // url
              duration: this.videoDuration ? Math.round(duration) : "videoDuration is false.", // 视频时长
              code: 200 // 状态码
            }
            console.log("upload success")
            // element upload onSuccess 上传成功钩子
            params.onSuccess(data)
          }
        })
        .catch(error => {
          console.log("upload error")
          console.log(error)
          // element upload onError 上传失败钩子
          params.onError(error)
        })
      }

    },
    beforeUpload(file) {
      console.log(file.type)
      // 是允许的类型
      const is_allowType = this.allowType.indexOf(file.type) >= 0
      // 文件大小判断
      const is_allowSize = file.size / 1024 / 1024 < this.allowSize;
      if (!is_allowType) {
        this.$message.error('未被允许的文件格式!');
      }
      if (!is_allowSize) {
        this.$message.error('文件大小不能超过 ' + this.allowSize + 'MB!');
      }
      return is_allowType && is_allowSize;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    customColorMethod(percentage) {
      if (percentage < 30) {
        return '#909399';
      } else if (percentage < 70) {
        return '#e6a23c';
      } else {
        return '#67c23a';
      }
    },
  },
  computed: {
    // ...mapState('d2admin/user', [
    //   'info'
    // ]),
    // ...mapState('d2admin/bucket', [
    //   'bucketParameter',
    //   'resourcePrefix'
    // ])
  },
  watch: {
    fileList() {
      this.hideUpload = this.fileList.length >= this.limit
    }
  },
}

</script>
<style lang="scss" scoped>
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/upload/index.vue